import { getErrorStringFromServerError, getLocalizedString } from "@icarius-localization/strings";
import {
  SEND_MESSAGE,
  SEND_MESSAGE_FULFILLED,
  SEND_MESSAGE_REJECTED,
  DELETE_CONVERSATION,
} from "./actionTypes";
import { formatDateHHMM } from "@icarius-utils/date";
import { cancelMessageBotAssistantAPI, deleteBotAssistantConversationAPI, sendMessageBotAssistantAPI } from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";

export const formatMessage = (message, isUser = false) => {
  return ({
    ...message,
    isUser,
    time: formatDateHHMM(new Date()),
  })
}

export const sendMessageBotAssistantAction = (conversationId, text, attachments) => async (dispatch) => {
  dispatch({
    type: SEND_MESSAGE,
    payload: {
      conversationId,
      message: formatMessage({ text, attachments }, true), // mensaje del usuario
    }
  });

  try {
    const formData = new FormData();
    formData.append("groupCode", conversationId);
    formData.append("text", text);
    if (attachments?.length) {
      Array.from(attachments).forEach((file) => {
        formData.append("FILES", file);
      });
    }

    const response = await sendMessageBotAssistantAPI(formData);
    dispatch({
      type: SEND_MESSAGE_FULFILLED,
      payload: {
        conversationId,
        message: formatMessage(response.data), // mensaje del bot
      }
    });

    return response;
  } catch (e) {
    dispatch({
      type: SEND_MESSAGE_REJECTED,
      payload: {
        conversationId,
        message: formatMessage({ text: getLocalizedString("defaultException"), status: "ERROR" }), // mensaje del bot
      }
    });
    return e.response;
  }
};

export const cancelMessageBotAssistantAction = (conversationId) => async (dispatch) => {
  try {
    const response = await cancelMessageBotAssistantAPI({ groupCode: conversationId });
    return response;
  } catch (e) {
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};

export const deleteBotAssistantConversationAction = (conversationId) => async (dispatch) => {
  dispatch({
    type: DELETE_CONVERSATION,
    payload: {
      conversationId,
      message: formatMessage({ text: getLocalizedString("botInitialMessage") })
    }
  });

  dispatch(openSnackbarAction({ msg: getLocalizedString("conversationDeletedOk"), severity: "success" }));
  try {
    const response = await deleteBotAssistantConversationAPI({ groupCode: conversationId });
    return response;
  } catch (e) {
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
  }
};